import Bb from 'backbone';
import queryString from 'query-string';
import _ from 'lodash';

import BaseFormView from '../../components/BaseForm';
import UserModel from '../../../models/User';
import Preloader from '../../../utils/Preloader';
import '../index.styl';
import { redirectTo } from '../../../../applications/NRL_Fantasy/utils';

const error_1_original =
	'Your password reset token is not correct or has expired. ' +
	'You can use the forgot password link to generate a new token.';
const error_1_new =
	'Your password reset token is incorrect or has expired. ' +
	'Use the forgot passwork link again to generate a new password ' +
	'reset email and follow the steps.';

const errorMappingServerToClient = {
	[error_1_original]: error_1_new
};

class ChangePasswordView extends BaseFormView {
	events() {
		return {
			'change @ui.form'                   : 'onChangeForm',
			'click @ui.change'                  : 'onClickNext',
		};
	}

	get className() {
		return "change-password-page";
	}

	ui() {
		return {
			form                    : '.js-change-password-form',
			password                : '.js-password',
			change                  : '.js-change',
		};
	}

	initialize() {
		this.model = new Bb.Model();

		this.setListeners();
		this.setDefaultValues();
	}

	setDefaultValues() {
		this.model.set({
			password: '',
			errors: {}
		})
	}

	setListeners() {
		this.listenTo(UserModel, 'user:change_password:success', this.onUserChangePasswordSuccess);
		this.listenTo(UserModel, 'user:change_password:fail', this.onUserChangePasswordFail);
	}

	getChangePasswordToken() {
		// Get url params
		const params = queryString.parse(location.search);
		return params.token;
	}

	async submit() {
		const errors = this.validate();

		if (errors) {
			this.attachValidationErrors(errors);
			return false;
		}

		Preloader.show();

		await UserModel.changePassword({
			token: this.getChangePasswordToken(),
			password: this.model.get('password')
		});

		Preloader.hide();
	}

	onUserChangePasswordSuccess() {
		redirectTo('/change-password-confirmation');
	}

	onUserChangePasswordFail(errors) {
		const parsed_errors = errors.map(
			error => errorMappingServerToClient[error.text] || error.text
		);
		this.attachValidationErrors({
			server_side: parsed_errors
		});
	}

	changeField(field_name) {
		this.model.set({
			[field_name]: this.getFormValues()[field_name]
		});

		const errors = this.validateField(field_name);
		const is_errors = !_.isUndefined(errors);
		const is_need_to_render = is_errors || (this.model.get('is_errors') && !is_errors);


		this.model.set({
			is_errors,
			errors: {
				...this.model.get('errors'),
				[field_name]: errors
			}
		});

		if (is_need_to_render) {
			this.render();
		}
	}

	getFormValues() {
		return {
			password        : this.getUI( 'password' ).val()
		};
	}

	validationRules() {
		return {
			password:  {
				presence: {
					allowEmpty: false,
					message: "Password is required"
				}
			}
		}
	}
}

export default ChangePasswordView;